var $1abc56118d256aa1$exports = {};
$1abc56118d256aa1$exports = {
    "maximum": `Maksimum`,
    "minimum": `Minimum`
};


export {$1abc56118d256aa1$exports as default};
//# sourceMappingURL=nb-NO.module.js.map
